import Axios from "axios";
import StackTrace from "stacktrace-js";
import { getConfig, remoteLogUrl } from "../helpers/urlHelper";
import { IBaseConfiguration } from "../interfaces/configuration/IBaseConfiguration";

const REMOTELOGGING_TRACE = 'trace';
const REMOTELOGGING_DEBUG = 'debug';
const REMOTELOGGING_INFO = 'info';
const REMOTELOGGING_WARNING = 'warning';
const REMOTELOGGING_ERROR = 'error';
const REMOTELOGGING_NONE = 'none';

const LOGLEVEL_TRACE = 0;
const LOGLEVEL_DEBUG = 1;
const LOGLEVEL_INFO = 2;
const LOGLEVEL_WARNING = 3;
const LOGLEVEL_ERROR = 4;
//CRITICAL 5
const LOGLEVEL_NONE = 6;

//Debug 1xxx
//Info 2xxx
//Warnings 3xxx
export const LOGWARNING_MFLOGIN_FAILED = 3010;
export const LOGWARNING_ADLOGIN_FAILED = 3011;
//Errors 4xxx
export const LOGERROR_VALIDATION_FAILED = 4010;
//Exceptions 5xxx
export const LOGEXCEPTION_UNHANDLED = 5010;
export const LOGEXCEPTION_PROMISE_REJECTED = 5011;
export const LOGEXCEPTION_STACKTRACE = 5012;

let baseConfiguration: IBaseConfiguration;

const getLogLevel = (level: string) => {
  switch(level.toLowerCase()) {
    case REMOTELOGGING_TRACE:
      return LOGLEVEL_TRACE;
    case REMOTELOGGING_DEBUG:
      return LOGLEVEL_DEBUG;
    case REMOTELOGGING_INFO:
      return LOGLEVEL_INFO;
    case REMOTELOGGING_WARNING:
      return LOGLEVEL_WARNING;
    case REMOTELOGGING_ERROR:
      return LOGLEVEL_ERROR;
    default:
      return LOGLEVEL_NONE;
  }
}

const log = async (logLevel: number, eventId: number, message: string, user: string, exceptionName?: string, stackTrace?: string) => {

  try {
    if(!baseConfiguration) {
      baseConfiguration = await getConfig();
    }
    if(logLevel < getLogLevel(baseConfiguration.remoteLoggingLevel ?? REMOTELOGGING_NONE)) {
      return;
    }
    const payload = {
      logLevel: logLevel,
      eventId: eventId,
      userId: user ? `${user}` : undefined,
      message: message ? `${message}` : undefined,
      exceptionName: exceptionName ? `${exceptionName}` : undefined,
      stackTrace: stackTrace ? `${stackTrace}` : undefined
    }
    const url = remoteLogUrl();
    return await Axios.post(url, payload, { baseURL: baseConfiguration.nvsApiUrl });
  } catch(e) {
    console.error(e);
  }
};

export const logTrace = (eventId: number, message: string, user?: string) => {
  console.trace(message);
  log(LOGLEVEL_TRACE, eventId, message, user);
}

export const logDebug = (eventId: number, message: string, user?: string) => {
  console.debug(message);
  log(LOGLEVEL_DEBUG, eventId, message, user);
}

export const logInfo = (eventId: number, message: string, user?: string) => {
  console.log(message);
  log(LOGLEVEL_INFO, eventId, message, user);
}

export const logWarning = (eventId: number, message: string, user?: string ) => {
  console.warn(message);
  log(LOGLEVEL_WARNING, eventId, message, user);
}

export const logError = (eventId: number, message: string, user?: string ) => {
  console.error(message);
  log(LOGLEVEL_ERROR, eventId, message, user);
}

export const logException = (eventId: number, error?: Error, user?: string) => {
  //Not logging to console since exceptions are already logged
  StackTrace.fromError(error).then(stack => {
    let stackText = "";
    for(let stackLine of stack) {
      stackText += ` at ${stackLine.functionName} (${stackLine.getFileName()}:${stackLine.lineNumber})\n`;
    }
    log(LOGLEVEL_ERROR, eventId, error.message, user, error.name, stackText);

  }).catch(e => {
    log(LOGLEVEL_ERROR, LOGEXCEPTION_STACKTRACE, error?.message ?? "Failed to parse stacktrace: " + e?.message, user, error?.name, error?.stack);
  });
}